export default __webpack_public_path__ + "static/media/ilSicredi_app_200px.31d90269.png";